var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"rounded-lg",attrs:{"outlined":"","loading":_vm.loading}},[_c('v-card-title',[_c('h6',[_vm._v("Acessos por sistema operacional")])]),_c('v-card-text',[_c('apexCharts',{attrs:{"type":"donut","height":"350","options":_vm.chartOptions,"series":_vm.chartSeries}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }